export var hostname = function hostname(_config, _data, globalConfig) {
  return {
    hostname: globalConfig.hostname
  };
};